import React from "react"

const Pullquotes = () => (
  <section>
    <div className="container mx-auto px-5 overflow-auto max-w-screen-lg">
      <blockquote className="max-w-xl">
        <p className="text-2xl font-heading">&quot;There is a wonderful chemical reaction that plays in our body that helps the romance in our life to wipe away the stress that troubles our relationships.</p>
        <cite className="text-lg mt-4 inline-block">&mdash;Dr. Fahad Karuppam Basheer</cite>
      </blockquote>
      <blockquote className="text-right mt-12 ml-auto max-w-xl float-right">
        <p className="text-2xl font-heading">&quot;Lorem ipsum dolor sit. Lorem ipsum dolor sit amet consectetur.</p>
        <cite className="text-lg mt-4 inline-block">&mdash;Lorem ipsum</cite>
      </blockquote>
    </div>
  </section>
)

export default Pullquotes